import React from 'react';
import SEO from '../../../../components/SEO/SEO';

import { Link } from 'react-router-dom';
import './EmailMarketingLegal.css';

const EmailMarketingLegal = () => {
    return (
        <div className="industry-service-page">
            <SEO 
                title="Email Marketing Legal Services | Digi Network" 
                description="Learn more about our Email Marketing Legal services to grow your business online with Digi Network." 
                canonical="/industries/legal/services/emailmarketinglegal" 
            />

            {/* Hero Section */}
            <section className="industry-service-hero">
                <div className="industry-service-hero-bg"></div>
                <div className="container">

                        
                    <div className="industry-service-hero-content">
                        <div className="label">EMAIL MARKETING</div>
                        <h1>Email Marketing for Legal</h1>
                        <p className="industry-service-hero-description">Build relationships, nurture leads, and drive consultation conversions with strategic email marketing campaigns. Our legal-focused email marketing helps you stay connected with clients and maximize customer lifetime value.</p>
                        <div className="industry-service-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                            Get Free Email Strategy
                            <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                            </svg>
                        </Link>
                        </div>
                    </div>
                </div>
            </section>
            {/* Stats Section */}
            <section className="seo-stats">
                <div className="container">
                    <div className="stats-grid">
                        <div className="stat-card">
                            <div className="stat-number">45%</div>
                            <div className="stat-label">Average Open Rate</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">12%</div>
                            <div className="stat-label">Click-Through Rate</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">300%</div>
                            <div className="stat-label">ROI Increase</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">24/7</div>
                            <div className="stat-label">Automation Running</div>
                        </div>
                    </div>
                </div>
            </section>


            {/* Legal Email Marketing Services */}
            <section className="industry-service-details">
                <div className="container">
                    <h2>Legal Email Marketing Services</h2>
                    <p>Email Marketing strategies designed specifically for legal businesses</p>

                    <div className="service-features-grid">
                        <div className="feature-card">
                            
                            <h3>Email Campaign Strategy</h3>
                            <p>Develop data-driven email strategies designed to engage clients and drive conversions.</p>
                            <ul>
                                <li>Campaign planning</li>
                                <li>Audience segmentation</li>
                                <li>Content strategy</li>
                                <li>Send time optimization</li>
                                <li>Campaign calendars</li>
                                <li>A/B testing strategy</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Email Design & Copywriting</h3>
                            <p>Create beautiful, engaging emails that capture attention and drive action.</p>
                            <ul>
                                <li>Custom email templates</li>
                                <li>Mobile-responsive design</li>
                                <li>Compelling copywriting</li>
                                <li>Brand-aligned aesthetics</li>
                                <li>Clear CTAs</li>
                                <li>Image optimization</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>List Building & Segmentation</h3>
                            <p>Grow your email list and segment clients for targeted messaging.</p>
                            <ul>
                                <li>Lead magnet creation</li>
                                <li>Signup form optimization</li>
                                <li>List segmentation</li>
                                <li>Behavioral targeting</li>
                                <li>Demographic segmentation</li>
                                <li>Engagement-based lists</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Marketing Automation</h3>
                            <p>Set up automated email sequences that nurture leads and drive consultation conversions.</p>
                            <ul>
                                <li>Welcome series</li>
                                <li>Abandoned cart emails</li>
                                <li>Post-purchase follow-ups</li>
                                <li>Re-engagement campaigns</li>
                                <li>Drip campaigns</li>
                                <li>Triggered emails</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Analytics & Optimization</h3>
                            <p>Track email performance and continuously optimize for better results.</p>
                            <ul>
                                <li>Open rate tracking</li>
                                <li>Click-through rates</li>
                                <li>Conversion tracking</li>
                                <li>List health monitoring</li>
                                <li>A/B test analysis</li>
                                <li>ROI measurement</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Integration & Deliverability</h3>
                            <p>Integrate with your CRM and ensure emails reach the inbox.</p>
                            <ul>
                                <li>CRM integration</li>
                                <li>E-commerce integration</li>
                                <li>Sender reputation management</li>
                                <li>Spam filter optimization</li>
                                <li>List hygiene</li>
                                <li>Authentication setup</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            {/* Why Choose Section */}
            <section className="why-seo-matters">
                <div className="container">
                    <div className="section-header">
                        <h2>Why Choose Our Email Marketing Services</h2>
                        <p>Discover what makes our email marketing services stand out from the competition</p>
                    </div>
                    <div className="why-seo-points">
                        <div className="why-point">
                            <h4>📧 High Engagement</h4>
                            <p>Create campaigns that people actually want to read with compelling content and design.</p>
                        </div>
                        <div className="why-point">
                            <h4>🤖 Smart Automation</h4>
                            <p>Set up workflows that nurture leads and customers automatically while you focus on your business.</p>
                        </div>
                        <div className="why-point">
                            <h4>🎯 Segmentation</h4>
                            <p>Send the right message to the right people at the right time with advanced segmentation.</p>
                        </div>
                        <div className="why-point">
                            <h4>📈 Data-Driven</h4>
                            <p>Make informed decisions based on real performance data and continuous A/B testing.</p>
                        </div>
                    </div>
                </div>
            </section>
            {/* Process Section */}
            <section className="seo-process">
                <div className="container">
                    <div className="section-header">
                        <div className="label">OUR APPROACH</div>
                        <h2>Our Email Marketing Process</h2>
                        <p>A proven methodology designed specifically for legal businesses</p>
                    </div>

                    <div className="process-grid">
                        <div className="process-step">
                            <div className="process-number">01</div>
                            <h3>Strategy & Planning</h3>
                            <p>Define your goals, audience segments, and email marketing roadmap.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">02</div>
                            <h3>Design & Content</h3>
                            <p>Create engaging email templates and compelling content that converts.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">03</div>
                            <h3>Automation Setup</h3>
                            <p>Build workflows that nurture leads and customers automatically.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">04</div>
                            <h3>Analyze & Improve</h3>
                            <p>Track performance metrics and continuously optimize for better results.</p>
                        </div>
                    </div>
                </div>
            </section>



            {/* Legal Email Marketing Process */}

            {/* CTA Section */}
            <section className="industry-service-cta">
                <div className="container">
                    <h2>Ready to Grow with Email Marketing?</h2>
                    <p>Get a free email marketing strategy and discover how we can help you engage clients and drive conversions.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Get Free Email Strategy
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default EmailMarketingLegal;
